<template>
    <div>
        <headline-container headline="Edit Subscription Type" :breadcrumbs="breadcrumbs">
            <button type="button" class="btn btn-white pull-right" @click="destroy">
                <i class="fa fa-trash"></i> Delete
            </button>
        </headline-container>

        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="row">
                <div class="col-xs-6">
                    <help-text>
                        <h3>
                            Edit Subscription Type
                        </h3>

                        <p>
                            Enter the details of the subscription type.
                        </p>

                        <button type="button" data-toggle="modal" data-target="#create-price-increase-modal"
                                class="btn btn-black btn-sm">
                            <i class="fa fa-plus"/> Increase Price
                        </button>
                    </help-text>
                </div>

                <div class="col-xs-18">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <form @submit.prevent="submit" class="form-horizontal">
                                <text-form-group
                                    v-model="data.name"
                                    name="name"
                                    label="Name"
                                    help-text="The name of the subscription type."
                                    :error="getError('name')"
                                ></text-form-group>

                                <number-form-group
                                    v-model="data.price"
                                    name="price"
                                    label="Price"
                                    help-text="The price of subscriptions with this type."
                                    :error="getError('price')"
                                ></number-form-group>

                                <number-form-group
                                    v-model="data.period"
                                    name="period"
                                    label="Period"
                                    help-text="The period (in months) of subscriptions with this type."
                                    :error="getError('period')"
                                ></number-form-group>

                                <number-form-group
                                    v-model="data.closes_after"
                                    name="closes_after"
                                    label="Closes After"
                                    help-text="The number of days that subscriptions with this type will remain open with an unpaid invoice."
                                    :error="getError('closes_after')"
                                ></number-form-group>

                                <number-form-group
                                    v-model="data.seats"
                                    name="seats"
                                    label="Seats"
                                    help-text="The number of seats that subscriptions with this type will grant on the portal."
                                    :error="getError('seats')"
                                ></number-form-group>

                                <select-form-group
                                    v-model="data.portal_id"
                                    name="portal_id"
                                    label="Portal"
                                    help-text="The portal where this subscription type exists."
                                    :error="getError('portal_id')"
                                    :nullable="true"
                                    :options="portalOptions"
                                ></select-form-group>

                                <hr>

                                <submit-form-group button-class="btn-black"></submit-form-group>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <create-price-increase-modal :subscription-type="subscriptionType" @created="subscriptionType = $event"/>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import CreatePriceIncreaseModal from '@/components/Modals/Subscriptions/PriceIncreases/Create'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
    components: {
        CreatePriceIncreaseModal,
        HeadlineContainer,
        HelpText,
        LoadingContainer,
        NumberFormGroup,
        SelectFormGroup,
        SubmitFormGroup,
        TextFormGroup
    },

    mixins: [Errors],

    props: ['id'],

    data() {
        return {
            subscriptionType: null,

            data: {},

            portals: [],

            loading: true
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        subscriptionType(value){
            this.data = {...value.attributes}
        }
    },

    computed: {
        breadcrumbs() {
            return [
                {url: '/subscription-types', text: 'Subscription Types'},
                {text: 'Edit'}
            ]
        },

        portalOptions() {
            return this.portals.map(portal => {
                return {
                    value: portal.id,
                    label: portal.attributes.name
                }
            })
        }
    },

    methods: {
        load() {
            Promise.all([
                http.get('/api/v2/subscription-types/' + this.id),
                http.get('/api/v2/portals')
            ]).then(responses => {
                this.subscriptionType = responses[0].data.data

                this.portals = responses[1].data.data

                this.loading = false
            })
        },

        submit() {
            http.put('/api/v2/subscription-types/' + this.id, this.data)
                .then(() => {
                    notify.success('The subscription type was saved')

                    this.$router.push('/subscription-types')
                })
                .catch(this.catchValidationErrors)
        },

        destroy() {
            modal.confirm('Are you sure that you want to delete the subscription type?', () => {
                http.delete('/api/v2/subscription-types/' + this.id)
                    .then(() => {
                        notify.success('The subscription type was deleted')

                        this.$router.push('/subscription-types')
                    })
            })
        }
    }
}
</script>
